<iu-prime-overlay #overlay appendTo="body" styleClass="iu-field-conflict-overlay" [handleAlign]="alignFn">
  <!-- built only while the panel is open: closed, its pipes and value formatting ran on every check, in every field -->
  @if (overlay.render) {
    <div
      class="iu-field-conflict-panel"
      role="dialog"
      data-cy="field-conflict-panel"
      [attr.aria-label]="'fieldConflict.title' | translate: { field: label }"
      [attr.data-cy-columnName]="field?.data?.columnName">
      <div class="iu-field-conflict-panel-title">
        <i aria-hidden="true" class="icon-triangle-exclamation"></i>
        <span>{{ 'fieldConflict.title' | translate: { field: label } }}</span>
      </div>

      <div class="iu-field-conflict-panel-choice is-current" data-cy="field-conflict-local">
        <div class="iu-field-conflict-panel-choice-text">
          <span class="iu-field-conflict-panel-choice-label">
            {{ 'fieldConflict.localValue' | translate }}
            <span class="iu-field-conflict-panel-badge">{{ 'fieldConflict.applied' | translate }}</span>
          </span>
          @if (format(localValue); as v) {
            <span class="iu-field-conflict-panel-value" [attr.title]="v">{{ v }}</span>
          } @else {
            <span class="iu-field-conflict-panel-value is-empty">{{ 'mergetool.empty' | translate }}</span>
          }
        </div>
        <button
          pButton
          type="button"
          class="p-button p-button-primary iu-field-conflict-panel-btn"
          data-cy="field-conflict-keep-local"
          [label]="'fieldConflict.keep' | translate"
          [attr.aria-label]="'mergetool.chooseLocal' | translate: { field: label }"
          (click)="keep($event, 'local')"></button>
      </div>

      <div class="iu-field-conflict-panel-choice" data-cy="field-conflict-remote">
        <div class="iu-field-conflict-panel-choice-text">
          <span class="iu-field-conflict-panel-choice-label">{{ 'fieldConflict.remoteValue' | translate }}</span>
          @if (format(remoteValue); as v) {
            <span class="iu-field-conflict-panel-value" [attr.title]="v">{{ v }}</span>
          } @else {
            <span class="iu-field-conflict-panel-value is-empty">{{ 'mergetool.empty' | translate }}</span>
          }
        </div>
        <button
          pButton
          autofocus
          type="button"
          class="p-button p-button-secondary iu-field-conflict-panel-btn"
          data-cy="field-conflict-keep-remote"
          [label]="'fieldConflict.keep' | translate"
          [attr.aria-label]="'mergetool.chooseRemote' | translate: { field: label }"
          (click)="keep($event, 'remote')"></button>
      </div>

      @if (canOpenMergeTool) {
        <div class="iu-field-conflict-panel-footer">
          <a href="#" data-cy="field-conflict-open-mergetool" (click)="openMergeTool($event)">{{
            'fieldConflict.seeAll' | translate
          }}</a>
        </div>
      }
    </div>
  }
</iu-prime-overlay>
